import React from "react";
import ApplicantMessagingWorkspace from "../components/applicant/ApplicantMessagingWorkspace";

export default function ApplicantMessages() {
  return <ApplicantMessagingWorkspace focusMode="messages" />;
}
